export default "__VITE_PUBLIC_ASSET__be5402d7__"